import { render, staticRenderFns } from "./RescheduleModal.vue?vue&type=template&id=670922c6&"
import script from "./RescheduleModal.vue?vue&type=script&lang=js&"
export * from "./RescheduleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports